<script>
    import _              from 'lodash'
    import Dropdown       from '../../shared/Dropdown.svelte'

    export let duration = null
    export let onChange = () => false

    const options = [
        { id: 1, value: 'unlimited'    , text: 'permanente' },
        { id: 2, value: 'session'      , text: 'sessão'     },
        { id: 3, value: 'user_defined' , text: 'definir'    },
    ]

    let debug     = false
    let mode      = 'dropdown'
    let icon      = ''
    let selected  = null
    let changes   = []
    let input     = optionGiven(duration) ? null : duration

    $: parsed   = parse(input)
    $: error    = mode === 'input' ? parsed !== input : false
    $: option   = optionGiven(duration, selected) 
    $: mode     = modeGiven(duration, selected, option)
    $: update(input, parsed, duration, selected, option, mode, error)


    function update(input, parsed, duration, selected, option, mode, error) {
        const diff = computeDiff(input, parsed, duration, selected, option, mode, error)
        changes = [...changes, {input, parsed, duration, selected, option, mode, error, diff}]
        //console.log(`d:${duration}, s:${selected}, i:${input}, p:${parsed}, o:${option ? option.value : null}, m:${mode}`)
        if('user_defined' === selected) {
            onChange(parsed === input ? parsed : null)
        } else if(selected) {
            onChange(selected)
        } else {
            //onChange(null)
        }
    }

    function reset() {
        selected = null
        input    = null
        duration = null
        onChange(null)
    }

    function computeDiff(input, parsed, duration, selected, option, mode, error) {
        if(changes.length === 0) {
            return null
        }

        const obj = { input, parsed, duration, selected, option, mode, error}
        const last = changes[changes.length - 1]

        const tmp = []
        Object.keys(last).map(k => {
            const prev = last[k]
            const next = obj[k]
            if(prev !== next) {
                tmp.push(k)
            }
        })
        return tmp
    }

    function neg(idx, column) {
        if(idx === 0)
            return false
        const d = changes[idx].diff
        return d.find(it => it === column)
    }

    function optionGiven(d, v) {
        return options.find(i => i.value === v || i.value === d)
    }

    function changed(op) {
        selected = op.value
    }

    function parse(i) {
        if(!i) return null

        const parseValue = (v) => {
            const accepted = ["s", "segundo", "segundos", "m", "minuto", "minutos", "d", "dia", "dias", "semana", "semanas", "mês", "mêses", "a", "ano", "anos"]
            const a = _.trim(v).split(" ")
            if(a.length === 2) {
                if(accepted.find(it => it === a[1])) {
                    return _.trim(v)
                }
            }
            return null
        }

        return parseValue(i)
    }

    function modeGiven(d, s, op) {
        if('user_defined' === s)
            return 'input'
        if(d && !op)
            return 'input'

        return 'dropdown'
    }

</script>
<!-- <input type="text" bind:value={duration}> -->
{#if mode === 'input'}
    <div class="ui  action input" class:error>
        <input type="text" bind:value={input} placeholder="1 dia">
        <button class="ui icon button" on:click={reset}>
            <i class="bars icon"></i>
        </button>
    </div>
    {#if false && !error}
        <i class="green check circle icon"></i> 
    {/if}

{:else}
    <Dropdown   text     = 'Validade'
                type     = 'button'
                selected = { option   }
                error    = { error    }
                noOption = { false    } 
                fluid    = { true     }
                options  = { options  }
                onChange = { changed  } />
{/if}

{#if debug}
    <table class="ui compact small table">
        <thead>
            <tr>
                <th>mode</th>
                <th>error</th>
                <th>selected</th>
                <th>option</th>
                <th>duration</th>
                <th>input</th>
                <th>parsed</th>
            </tr>
        </thead>
        <tbody>
            {#each changes as it, idx}
                <tr>
                    <td class:negative={neg(idx, 'mode')}     >{it.mode}</td>
                    <td class:negative={neg(idx, 'error')}    >{it.error}</td>
                    <td class:negative={neg(idx, 'selected')} >{it.selected}</td>
                    <td class:negative={neg(idx, 'option')}   >{it.option ? it.option.value : null}</td>
                    <td class:negative={neg(idx, 'duration')} >{it.duration}</td>
                    <td class:negative={neg(idx, 'input')}    >{it.input}</td>
                    <td class:negative={neg(idx, 'parsed')}   >{it.parsed}</td>
                </tr>
            {/each}
        </tbody>
    </table>
{/if}
